import { TypedError } from './errors'

/**
 * 创建默认语言包
 */
TypedError.setLocales({
  'en-US': {}, // 美国
  'zh-CN': {}, // 中国大陆
  'zh-HK': {} // 中国香港
})

/**
 * 创建默认映射
 */
TypedError.setLocalesAlias({
  en: 'en-US', // 英语
  'en-AU': 'en-US', // 澳大利亚
  'en-CA': 'en-US', // 加拿大
  'en-GB': 'en-US', // 英国
  'en-NZ': 'en-US', // 新西兰
  'en-WW': 'en-US', // 世界
  zh: 'zh-CN', // 中文
  'zh-CHS': 'zh-CN', // 中文简体
  'zh-CHT': 'zh-HK', // 中文繁体
  'zh-Hans': 'zh-CN', // 中文简体
  'zh-Hant': 'zh-HK', // 中文繁体
  'zh-MO': 'zh-HK', // 中国澳门
  'zh-MY': 'zh-HK', // 马来西亚
  'zh-SG': 'zh-HK', // 新加坡
  'zh-TW': 'zh-HK' // 中国台湾
})

export const defaultLocales = TypedError.getLocales()
